import React from "react";

const setUser = (userData) =>{
    return{
        type: 'SET_USER',
        payload:userData
    }
};

export default setUser;